import { EntityState, Validator } from 'breeze-client';
import { ValidationContext } from 'breeze-client/src/validate';

interface FunctionValidationContext extends ValidationContext {
  propertyFn: (e: any) => string;
}

/** Validate that the result of context.propertyFn is unique for all entities in the group */
const uniqueFnValidatorFn = (val: any, context: FunctionValidationContext): boolean => {
  const fn = context.propertyFn as (e: any) => string;
  const entity = context.entity;
  val = fn(entity);
  const array = entity.entityAspect.entityGroup.getEntities([EntityState.Added, EntityState.Modified, EntityState.Unchanged]);
  for (const e of array) {
    if (e !== entity && fn(e) === val) {
        return false;
      }
    }
  return true;
};

/** For TimeCategory - validate parent+description are unique */
export const uniqueParentAndDescriptionValidator = new Validator(
  'uniqueParentAndDescription',
  uniqueFnValidatorFn,
  {
    propertyFn: (e) => '' + e.parentId + ':' + e.description,
    messageTemplate: 'description must be unique'
  }
);
